import React from 'react';
import logo from 'assets/images/logo/recommended-immunization-child.png';

const ChildImmunization = () => {
  const styles = {
    body: {
      fontFamily: 'Arial, sans-serif',
      // margin: '20px',
      // padding: '20px',
      backgroundColor: '#f4f4f4'
    },
    container: {
      background: 'white',
      // padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)'
    },

  }
  return (
    <div className='container bg-white p-4 rounded'>
      <div style={styles.body}>
        <div className="container" style={styles.container}>
          <h1 style={{ color: '#333' }}>Recommended immunization schedule for children age 0 through 6 years – United States, 2025 (for those who
            fall behind or start late, refer to UpToDate content related to the catch-up schedule)</h1>

          <img src={logo} alt="brand-logo" width="max" style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px', marginTop: '10px', display: 'block' }} />
          <br />

          <div style={{ width: 'max', height: '1px', backgroundColor: 'black' }}></div>
          <br />

          <h2 style={{ color: '#333' }}>Immunization Schedule Guidelines</h2>
          <p>This schedule is recommended by the Advisory Committee on Immunization Practices (ACIP) and approved by the
            following organizations:</p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Centers for Disease Control and Prevention (CDC)</li>
            <li>American Academy of Pediatrics (AAP)</li>
            <li>American Academy of Family Physicians (AAFP)</li>
            <li>American College of Obstetricians and Gynecologists (ACOG)</li>
            <li>American College of Nurse-Midwives (ACNM)</li>
            <li>American Academy of Physician Associates (AAPA)</li>
            <li>National Association of Pediatric Nurse Practitioners (NAPNAP)</li>
          </ul>
          <p>Consult relevant ACIP recommendations for detailed guidance.</p>
          <p>When a vaccine is not administered at the recommended age, administer it at a subsequent visit.</p>
          <p>Use combination vaccines instead of separate injections when appropriate.</p>
          <p>Report clinically significant adverse events to the <a href="https://vaers.hhs.gov" target="_blank">Vaccine
            Adverse Event Reporting System (VAERS)</a> online or by telephone: <strong>800-822-7967</strong>.</p>
          <p>Report suspected cases of reportable vaccine-preventable diseases or outbreaks to your state or local health
            department.</p>
          <p>For information about precautions and contraindications, refer to the <a
            href="https://www.cdc.gov/vaccines/hcp/imz-best-practices/contraindications-precautions.html"
            target="_blank">CDC guidelines</a>.</p>
          <p>For information regarding vaccination in the setting of a vaccine-preventable disease outbreak, contact your
            state or local health department.</p>

          <div style={{ width: 'max', height: '1px', backgroundColor: 'black' }}></div>
          <br />
          <h2 style={{ color: '#333' }}>Vaccine Definitions</h2>
          <p>1vCOV-aPS: adjuvanted, protein subunit COVID-19 vaccine; 1vCOV-mRNA: monovalent mRNA COVID-19 vaccine;
            anti-HBs: hepatitis B surface antibody; COVID-19: coronavirus disease 2019; HBeAg: hepatitis B e antigen;
            HBIG: hepatitis B immune globulin; HBsAg: hepatitis B surface antigen; IIV3: trivalent inactivated influenza
            vaccine; LAIV3: trivalent live attenuated influenza vaccine; MenACWY-CRM: Menveo; MenACWY-TT: MenQuadfi;
            mIU: milli-international units; MMRV: combined measles, mumps, rubella, and varicella vaccine (ProQuad);
            PCV13: 13-valent pneumococcal conjugate vaccine; PCV15: 15-valent pneumococcal conjugate vaccine; PCV20:
            20-valent pneumococcal conjugate vaccine; PPSV23: Pneumovax 23; RSV: respiratory syncytial virus; RV1:
            Rotarix; RV5: RotaTeq.</p>
          <h2 style={{ color: '#333' }}>Respiratory Syncytial Virus (RSV) Vaccination</h2>
          <p>(Minimum age: Birth)</p>
          <p>Infants born October through March in most of the continental United States:</p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Birthing parent did not receive RSV vaccine or vaccination status unknown: Administer 1 dose nirsevimab
              within 1 week of birth.</li>
            <li>Birthing parent received RSV vaccine &lt;14 days prior to delivery: Administer 1 dose nirsevimab within
              1 week of birth.</li>
            <li>Birthing parent received RSV vaccine at least 14 days prior to delivery: Nirsevimab not needed.</li>
          </ul>
          <p>Infants born April through September in most of the continental United States:</p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Administer 1 dose nirsevimab shortly before start of RSV season if necessary.</li>
          </ul>
          <h2 style={{ color: '#333' }}>Hepatitis B (HepB) Vaccination</h2>
          <p>(Minimum age: Birth)</p>
          <p>Routine vaccination (birthing parent is HBsAg-negative):</p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>3-dose series at age 0, 1-2, and 6-18 months.</li>
            <li>Birth weight ≥2 kg: 1 dose within 24 hours of birth.</li>
          </ul>
          <p>Birthing parent is HBsAg-positive:</p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Administer HepB vaccine and HBIG within 12 hours of birth.</li>
            <li>Final dose at age 6 months (minimum age 24 weeks).</li>
          </ul>
          <h2 style={{ color: '#333' }}>Rotavirus (RV) Vaccination</h2>
          <p>(Minimum age: 6 weeks)</p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>RV1 (Rotarix): 2-dose series at age 2 and 4 months.</li>
            <li>RV5 (RotaTeq): 3-dose series at age 2, 4, and 6 months.</li>
          </ul>
          <h2 style={{ color: '#333' }}>Diphtheria, Tetanus, and Acellular Pertussis (DTaP) Vaccination</h2>
          <p>(Minimum age: 6 weeks, except for specific combinations at 4 years)</p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Routine 5-dose series at 2, 4, 6, 15-18 months, and 4-6 years.</li>
          </ul>

          <div style={{ width: 'max', height: '1px', backgroundColor: 'black' }}></div>
          <br />

          <h2 style={{ color: '#333' }}>Haemophilus influenzae type b (Hib) Vaccination</h2>
          <p><strong>Minimum age:</strong> 6 weeks</p>
          <h3 style={{ color: '#333' }}>Routine vaccination:</h3>
          <ul style={{ paddingLeft: '20px' }}>
            <li>ActHIB, Hiberix, Pentacel, or Vaxelis: 4-dose series (2, 4, 6 months + booster at 12-15 months).</li>
            <li>PedvaxHIB: 3-dose series (2, 4 months + booster at 12-15 months).</li>
            <li>Vaxelis is <strong>not recommended</strong> as a booster dose.</li>
          </ul>
          <h3 style={{ color: '#333' }}>Special Situations:</h3>
          <p>Refer to ACIP recommendations for high-risk groups (e.g., chemotherapy, HIV, asplenia, etc.).</p>

          <h2 style={{ color: '#333' }}>Pneumococcal Vaccination</h2>
          <p><strong>Minimum age:</strong> 6 weeks (PCV15, PCV20), 2 years (PPSV23)</p>
          <h3 style={{ color: '#333' }}>Routine vaccination with PCV:</h3>
          <ul style={{ paddingLeft: '20px' }}>
            <li>4-dose series at 2, 4, 6, and 12-15 months.</li>
            <li>PCV15 and PCV20 can be used interchangeably.</li>
          </ul>
          <h3 style={{ color: '#333' }}>Special Situations:</h3>
          <p>High-risk conditions include cerebrospinal fluid leak, chronic diseases, immunocompromised conditions, and
            more.</p>

          <h2 style={{ color: '#333' }}>Inactivated Poliovirus (IPV) Vaccination</h2>
          <p><strong>Minimum age:</strong> 6 weeks</p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>4-dose series at 2, 4, 6-18 months, and 4-6 years.</li>
            <li>Final dose must be on/after 4 years old and at least 6 months after the previous dose.</li>
          </ul>

          <h2 style={{ color: '#333' }}>COVID-19 Vaccination</h2>
          <p><strong>Minimum age:</strong> 6 months (Pfizer-BioNTech & Moderna)</p>
          <h3 style={{ color: '#333' }}>Age 6 months - 4 years:</h3>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Unvaccinated: 2-dose series (Moderna) or 3-dose series (Pfizer-BioNTech).</li>
            <li>Previously vaccinated: Follow-up doses based on prior doses.</li>
          </ul>
          <h3 style={{ color: '#333' }}>Age 5-6 years:</h3>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Unvaccinated: 1 dose of updated (2024-2025 formula) Moderna or Pfizer-BioNTech.</li>
            <li>Previously vaccinated: 1 follow-up dose at least 8 weeks after the last dose.</li>
          </ul>
          <h3 style={{ color: '#333' }}>Immunocompromised Individuals:</h3>
          <p>Special schedules apply. See <a
            href="https://www.cdc.gov/vaccines/covid-19/clinical-considerations/covid-19-vaccines-us.html"
            target="_blank">CDC guidelines</a>.</p>

          <div style={{ width: 'max', height: '1px', backgroundColor: 'black' }}></div>
          <br />

          <h2 style={{ color: '#333' }}>Influenza Vaccination</h2>
          <p><strong>Minimum age:</strong> 6 months for inactivated influenza vaccine (IIV3); 2 years for live attenuated
            influenza vaccine (LAIV3)</p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Use any influenza vaccine appropriate for age and health status annually.</li>
            <li>Children aged 6 months through 8 years:
              <ul style={{ paddingLeft: '20px' }}>
                <li>2 doses separated by at least 4 weeks if they have received fewer than 2 influenza vaccine doses
                  before July 1, 2024, or if their vaccination history is unknown.</li>
                <li>1 dose if they have received at least 2 influenza vaccine doses before July 1, 2024.</li>
              </ul>
            </li>
            <li>For the latest guidelines, refer to:
              <ul style={{ paddingLeft: '20px' }}>
                <li><a href="https://www.cdc.gov/mmwr/volumes/73/rr/rr7305a1.htm" target="_blank">2024-2025
                  season</a></li>
                <li>2025-2026 ACIP influenza vaccine recommendations</li>
              </ul>
            </li>
          </ul>

          <h2 style={{ color: '#333' }}>Measles, Mumps, and Rubella (MMR) Vaccination</h2>
          <p><strong>Minimum age:</strong> 12 months for routine vaccination</p>
          <h3 style={{ color: '#333' }}>Routine vaccination:</h3>
          <ul style={{ paddingLeft: '20px' }}>
            <li>2-dose series at age 12 through 15 months and age 4 through 6 years.</li>
            <li>MMR or MMRV may be administered.</li>
            <li>For dose 1 in children aged 12 through 47 months, it is recommended to administer MMR and varicella
              vaccines separately. MMRV may be used if preferred.</li>
          </ul>
          <h3 style={{ color: '#333' }}>International travel:</h3>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Infants age 6 through 11 months: 1 dose before departure; revaccinate with a 2-dose series at age 12
              through 15 months and dose 2 at least 4 weeks later.</li>
            <li>Unvaccinated children age 12 months or older: 2 doses at least 4 weeks apart before departure.</li>
            <li>Previously received 1 dose and age 12 months or older: Administer dose 2 at least 4 weeks after dose 1.
            </li>
          </ul>

          <h2 style={{ color: '#333' }}>Varicella (VAR) Vaccination</h2>
          <p><strong>Minimum age:</strong> 12 months</p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>2-dose series at 12 through 15 months and 4 through 6 years.</li>
            <li>VAR or MMRV may be administered.</li>
            <li>Dose 2 may be administered as early as 3 months after dose 1.</li>
          </ul>

          <h2 style={{ color: '#333' }}>Hepatitis A (HepA) Vaccination</h2>
          <p><strong>Minimum age:</strong> 12 months for routine vaccination</p>
          <h3 style={{ color: '#333' }}>Routine vaccination:</h3>
          <ul style={{ paddingLeft: '20px' }}>
            <li>2-dose series (minimum interval: 6 months) at age 12 through 23 months.</li>
          </ul>
          <h3 style={{ color: '#333' }}>International travel:</h3>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Infants age 6 through 11 months: 1 dose before departure; revaccinate with 2 doses, separated by at
              least 6 months, between age 12 and 23 months.</li>
            <li>Unvaccinated individuals age 12 months or older: Administer dose 1 as soon as travel is considered.</li>
          </ul>

          <h2 style={{ color: '#333' }}>Meningococcal Serogroup A, C, W, Y (MenACWY) Vaccination</h2>
          <p><strong>Minimum age:</strong> 2 months for MenACWY-CRM (Menveo); 2 years for MenACWY-TT (MenQuadfi)</p>
          <h3 style={{ color: '#333' }}>Special situations:</h3>
          <ul style={{ paddingLeft: '20px' }}>
            <li>For high-risk groups including anatomic or functional asplenia, HIV infection, persistent complement
              component deficiency, complement inhibitor use, and travel to countries with hyperendemic or epidemic
              meningococcal disease.</li>
            <li>MenACWY-CRM (Menveo) has 2 formulations: lyophilized and liquid. The liquid formulation should not be
              used before age 10 years.</li>
          </ul>

          <h2 style={{ color: '#333' }}>Influenza Vaccination</h2>
          <p><strong>Minimum age:</strong> 6 months for inactivated influenza vaccine (IIV3); 2 years for live attenuated
            influenza vaccine (LAIV3)</p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Use any influenza vaccine appropriate for age and health status annually.</li>
            <li>Children aged 6 months through 8 years:
              <ul style={{ paddingLeft: '20px' }}>
                <li>2 doses separated by at least 4 weeks if they have received fewer than 2 influenza vaccine doses
                  before July 1, 2024, or if their vaccination history is unknown.</li>
                <li>1 dose if they have received at least 2 influenza vaccine doses before July 1, 2024.</li>
              </ul>
            </li>
            <li>For the latest guidelines, refer to:
              <ul style={{ paddingLeft: '20px' }}>
                <li><a href="https://www.cdc.gov/mmwr/volumes/73/rr/rr7305a1.htm" target="_blank">2024-2025
                  season</a></li>
                <li>2025-2026 ACIP influenza vaccine recommendations</li>
              </ul>
            </li>
          </ul>

          <h2 style={{ color: '#333' }}>Measles, Mumps, and Rubella (MMR) Vaccination</h2>
          <p><strong>Minimum age:</strong> 12 months for routine vaccination</p>
          <h3 style={{ color: '#333' }}>Routine vaccination:</h3>
          <ul style={{ paddingLeft: '20px' }}>
            <li>2-dose series at age 12 through 15 months and age 4 through 6 years.</li>
            <li>MMR or MMRV may be administered.</li>
            <li>For dose 1 in children aged 12 through 47 months, it is recommended to administer MMR and varicella
              vaccines separately. MMRV may be used if preferred.</li>
          </ul>
          <h3 style={{ color: '#333' }}>International travel:</h3>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Infants age 6 through 11 months: 1 dose before departure; revaccinate with a 2-dose series at age 12
              through 15 months and dose 2 at least 4 weeks later.</li>
            <li>Unvaccinated children age 12 months or older: 2 doses at least 4 weeks apart before departure.</li>
            <li>Previously received 1 dose and age 12 months or older: Administer dose 2 at least 4 weeks after dose 1.
            </li>
          </ul>

          <h2 style={{ color: '#333' }}>Varicella (VAR) Vaccination</h2>
          <p><strong>Minimum age:</strong> 12 months</p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>2-dose series at 12 through 15 months and 4 through 6 years.</li>
            <li>VAR or MMRV may be administered.</li>
            <li>Dose 2 may be administered as early as 3 months after dose 1.</li>
          </ul>

          <h2 style={{ color: '#333' }}>Hepatitis A (HepA) Vaccination</h2>
          <p><strong>Minimum age:</strong> 12 months for routine vaccination</p>
          <h3 style={{ color: '#333' }}>Routine vaccination:</h3>
          <ul style={{ paddingLeft: '20px' }}>
            <li>2-dose series (minimum interval: 6 months) at age 12 through 23 months.</li>
          </ul>
          <h3 style={{ color: '#333' }}>International travel:</h3>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Infants age 6 through 11 months: 1 dose before departure; revaccinate with 2 doses, separated by at
              least 6 months, between age 12 and 23 months.</li>
            <li>Unvaccinated individuals age 12 months or older: Administer dose 1 as soon as travel is considered.</li>
          </ul>

          <h2 style={{ color: '#333' }}>Meningococcal Serogroup A, C, W, Y (MenACWY) Vaccination</h2>
          <p><strong>Minimum age:</strong> 2 months for MenACWY-CRM (Menveo); 2 years for MenACWY-TT (MenQuadfi)</p>
          <h3 style={{ color: '#333' }}>Special situations:</h3>
          <ul style={{ paddingLeft: '20px' }}>
            <li>For high-risk groups including anatomic or functional asplenia, HIV infection, persistent complement
              component deficiency, complement inhibitor use, and travel to countries with hyperendemic or epidemic
              meningococcal disease.</li>
            <li>MenACWY-CRM (Menveo) has 2 formulations: lyophilized and liquid. The liquid formulation should not be
              used before age 10 years.</li>
          </ul>

          <div style={{ width: 'max', height: '1px', backgroundColor: 'rgb(190, 184, 184)' }}></div>
          <br />
          <footer>
            <p>Information sourced from uptodate.com</p>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default ChildImmunization; 